module.exports = __webpack_public_path__ + "static/img/guide-20.20a99316.png";